import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import OrderSuccess from "@/components/OrderSuccess";

export default function Success() {
  const loc = useLocation();
  const nav = useNavigate();
  const order = loc.state?.order;
  if (!order) {
    nav("/");
    return null;
  }
  return <OrderSuccess order={order} />;
}
